export const GET_PATIENT_REQ = "GET_PATIENT_REQ";
export const GET_PATIENT_SUCCESS = "GET_PATIENT_SUCCESS";
export const GET_PATIENT_FAIL = "GET_PATIENT_FAIL";

export const POST_PATIENT_REQ = "POST_PATIENT_REQ";
export const POST_PATIENT_SUCCESS = "POST_PATIENT_SUCCESS";
export const POST_PATIENT_FAIL = "POST_PATIENT_FAIL";

export const UPDATE_STATUS = "UPDATE_STATUS";
// export const GET_DOCTOR_SUCCESS="GET_DOCTOR_SUCCESS";
// export const GET_DOCTOR_FAIL="GET_DOCTOR_FAIL";
